import { render, staticRenderFns } from "./newsDetail.vue?vue&type=template&id=6b5375a5&comments=true"
import script from "./newsDetail.vue?vue&type=script&lang=ts"
export * from "./newsDetail.vue?vue&type=script&lang=ts"
import style0 from "./newsDetail.vue?vue&type=style&index=0&id=6b5375a5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports